var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark-circle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1823",
    "data-name": "Rectangle 1823",
    width: 40,
    height: 40,
    fill: "#ffc600",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8531",
    "data-name": "Group 8531",
    transform: "translate(-0.912 -0.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M20.961,7.334a3.586,3.586,0,0,1,2.952,2.03L35.214,28.2c1.627,2.7.371,4.919-2.783,4.919H9.491c-3.154,0-4.41-2.216-2.783-4.919l11.3-18.837a3.586,3.586,0,0,1,2.952-2.03m0-3.823a7.336,7.336,0,0,0-6.23,3.883L3.429,26.235a7.148,7.148,0,0,0-.449,7.322,7.157,7.157,0,0,0,6.511,3.387H32.43a7.153,7.153,0,0,0,6.511-3.386,7.152,7.152,0,0,0-.449-7.322L27.191,7.4a7.33,7.33,0,0,0-6.23-3.888Z",
    transform: "translate(0 0)",
    fill: "#ffc600"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 2.485,
    cy: 2.485,
    r: 2.485,
    transform: "translate(18.475 24.9)",
    fill: "#ffc600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M16.234,11.367a2.866,2.866,0,1,0-5.523,1.074c1.059,2.63,2.655,6.572,2.655,6.572l2.659-6.572A2.937,2.937,0,0,0,16.234,11.367Z",
    transform: "translate(7.594 4.548)",
    fill: "#ffc600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M0,0A4.55,4.55,0,0,0,2.364,1.1,3.261,3.261,0,0,0,4.424,0V13.487a4.272,4.272,0,0,0-2.295-1.072A3.551,3.551,0,0,0,0,13.487Z",
    transform: "translate(23.618 9.43) rotate(-31)",
    fill: "#ffc600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.5232a89917e652e42a99c3e245935985.svg";
export { ForwardRef as ReactComponent };